import React from 'react';
import { Container, Grid, makeStyles } from '@material-ui/core';
import Page from 'src/components/Page';
import PedidoDetails from './PedidoDetails';
import { useLocation } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const PedidosView = () => {
  const classes = useStyles();

  const location = useLocation();

  return (
    <Page className={classes.root} title="Pedido">
      <Container maxWidth="lg">
        <Grid container spacing={3}>
          <Grid item lg={11} md={12} xs={12}>
            <PedidoDetails
              uuid={location?.state?.order?.uuid}
              permissions={location?.state?.permissions}
            />
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
};

export default PedidosView;
